"use client";
import { PencilIcon } from "@heroicons/react/24/outline";
import Link from "next/link";

export default function SurveyButtonComp() {
  return (
    <div className="fixed right-4 bottom-32 w-12 h-12 z-50 group">
      <Link
        href="/survey"
        className="bg-accent rounded-xl lg:rounded-2xl text-white block p-3 shadow-md"
      >
        <PencilIcon className="text-lg" />
      </Link>
      <span className="absolute text-center right-0 top-3 -translate-x-1/2 scale-0 transition-all rounded-xl bg-green text-white text-sm px-2 py-1 opacity-0 group-hover:scale-100 group-hover:opacity-100 w-28">
        Isi survey yuk
      </span>
    </div>
  );
}
